function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_96",
  "data-name": "Group 96"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_92",
  "data-name": "Group 92",
  transform: "translate(86.939 29.178)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_21",
  "data-name": "Line 21",
  x2: 67.292,
  transform: "translate(2.257 2.256)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_327",
  "data-name": "Path 327",
  d: "M158.422,18.2H91.132a2.257,2.257,0,0,1,0-4.514h67.29a2.257,2.257,0,1,1,0,4.514Z",
  transform: "translate(-88.875 -13.685)",
  fill: "#141414"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_328",
  "data-name": "Path 328",
  d: "M84.357,26.423H69.679V11.848a2.257,2.257,0,0,1,4.514,0V21.91H84.357a2.257,2.257,0,0,1,0,4.514Z",
  transform: "translate(-40.501 7.268)",
  fill: "#141414"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_93",
  "data-name": "Group 93",
  transform: "translate(63.809 57.96)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_22",
  "data-name": "Line 22",
  x2: 90.424,
  transform: "translate(2.255 2.256)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_329",
  "data-name": "Path 329",
  d: "M173.866,27.764H83.445a2.257,2.257,0,0,1,0-4.514h90.421a2.257,2.257,0,1,1,0,4.514Z",
  transform: "translate(-81.188 -23.25)",
  fill: "#141414"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_94",
  "data-name": "Group 94",
  transform: "translate(10.962 87.388)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_23",
  "data-name": "Line 23",
  x2: 143.27,
  transform: "translate(2.257 2.257)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_330",
  "data-name": "Path 330",
  d: "M209.15,37.544H65.882a2.257,2.257,0,0,1,0-4.514H209.15a2.257,2.257,0,1,1,0,4.514Z",
  transform: "translate(-63.625 -33.03)",
  fill: "#141414"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_95",
  "data-name": "Group 95",
  transform: "translate(10.962 116.494)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_24",
  "data-name": "Line 24",
  x2: 143.27,
  transform: "translate(2.257 2.256)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_331",
  "data-name": "Path 331",
  d: "M209.15,47.217H65.882a2.257,2.257,0,0,1,0-4.514H209.15a2.257,2.257,0,1,1,0,4.514Z",
  transform: "translate(-63.625 -42.703)",
  fill: "#141414"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_332",
  "data-name": "Path 332",
  d: "M91.417,66.855a31.434,31.434,0,1,1,31.432-31.432A31.47,31.47,0,0,1,91.417,66.855Zm0-58.354a26.92,26.92,0,1,0,26.919,26.922A26.952,26.952,0,0,0,91.417,8.5Z",
  transform: "translate(-59.982 -3.988)",
  fill: "#3d99b8"
}));

var SvgWaitingForPayment = function SvgWaitingForPayment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_98",
    "data-name": "Group 98",
    width: 158.743,
    height: 121.008,
    viewBox: "0 0 158.743 121.008",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWaitingForPayment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/WaitingForPayment.090644ab.svg";
export { ForwardRef as ReactComponent };